// extracted by mini-css-extract-plugin
export default {"container":"_5nqSL","right":"rRXPA","text":"czDzn","recording":"PO4g9","recordingText":"jg6s0","tooltipContainer":"Xno+J","controlButtonText":"wmVsa","leaveButton":"_9jF4t"};